import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as Router } from 'react-router-dom';

import { App } from './App.tsx';
import { LoadingSpinner } from './components/loading/LoadingSpinner';
import './i18n';
import './index.css';
import { history, store } from './store/store.ts';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<LoadingSpinner fullScreen />}>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-expect-error*/}
        <Router history={history}>
          <App />
        </Router>
      </Suspense>
    </Provider>
  </React.StrictMode>,
);
